import { bunja } from 'bunja';
import { atom } from 'jotai';

import { tradingLeaderboardBunja } from '../../../../trading-leaderboard-page/bunja';
import { tierInfos, tradingLeaderboardTiers } from '../../../../trading-leaderboard-page/shared/constants';

export const leagueLeaderboardOnboardingBunja = bunja(() => {
  const { tierDescriptionsAtom } = bunja.use(tradingLeaderboardBunja);
  const descriptionsAtom = atom((get) => {
    const tierDescriptions = get(tierDescriptionsAtom);
    if (!tierDescriptions) return;
    return tradingLeaderboardTiers.map((tier) => [tierInfos[tier].label, tierDescriptions[tier]]);
  });
  return { descriptionsAtom };
});
leagueLeaderboardOnboardingBunja.debugLabel = 'leagueLeaderboardOnboardingBunja';
